import { useState } from "react";
import cls from "classnames";

import Modal from "@qoohoo/common/library/modals/Modal";
import InviteModal from "./modals/InviteModal";
import useSessionStore from "../../store/sessionStore";
import * as Track from "@qoohoo/common/utils/analytics/track";
import BottomSheetModalHOC from "@qoohoo/common/library/modals/BottomSheetModalHOC";
import { getRoundedMembersCount } from "@qoohoo/common/utils/number";

const ShareBar = ({ channelDetails, customConfig }) => {
  const currentUser = useSessionStore((state) => state.userData);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const memberCount = getRoundedMembersCount(
    channelDetails.total_number_of_subscribers
  );

  const isOwner = channelDetails.creator.uid === currentUser.uid;
  const isPrivate = channelDetails.is_private;
  const showShareButton = isOwner || !isPrivate;

  const hideMembers = channelDetails.hide_members ?? false;

  const showMembers = !hideMembers;

  function getShareMessage() {
    let message = "Spread the word. Invite members!";

    if (!isOwner) {
      if (isPrivate) {
        message = "Members in the channel";
      } else {
        message = "Spread the word. Invite friends!";
      }
    }

    return message;
  }

  function openInviteModal() {
    setInviteModalOpen(true);
  }

  function closeInviteModal() {
    setInviteModalOpen(false);
  }

  return (
    <>
      <div
        className={cls(
          "flex justify-between items-center py-3 px-2.5 sm:py-4 sm:px-6 rounded-xl mt-12 sm:mt-14 md:mt-16 bg-[#22272B]",
          { "flex-row-reverse": !showShareButton }
        )}
      >
        {channelDetails.latest_subscribers?.length ? (
          <div
            className={cls(
              "flex children:bg-[#16191B] text-xs sm:text-base font-semibold sm:font-bold",
              { "mr-2": showShareButton }
            )}
          >
            {channelDetails?.latest_subscribers?.map((sub, id) => {
              return (
                <div
                  key={id}
                  className={cls(
                    "h-9 w-9 sm:w-12 sm:h-12 border-2 border-[#22272B] rounded-full overflow-hidden select-none",
                    {
                      "-ml-3 sm:-ml-4":
                        id !== 0 &&
                        channelDetails?.latest_subscribers.length > 0,
                    }
                  )}
                >
                  <img
                    src={sub.avatar.url}
                    alt=""
                    className="object-cover object-center"
                  />
                </div>
              );
            })}
            {showMembers && channelDetails.total_number_of_subscribers > 4 && (
              <div
                className={cls(
                  "h-9 w-9 sm:w-12 sm:h-12 border-2 border-[#22272B] rounded-full flex items-center justify-center select-none",
                  {
                    "-ml-3 sm:-ml-4":
                      channelDetails?.latest_subscribers.length > 0,
                  }
                )}
              >
                {memberCount}
              </div>
            )}
          </div>
        ) : null}
        <span
          className={cls("sm:font-medium sm:text-center sm:block font-inter", {
            "hidden text-sm sm:text-base text-left":
              channelDetails.total_number_of_subscribers > 0,
          })}
        >
          {getShareMessage()}
        </span>
        {showShareButton && (
          <button
            onClick={openInviteModal}
            className="text-sm md:text-base ml-2 font-medium py-2.5 px-6 sm:py-3 sm:px-8 text-white bg-gradient-to-br from-[#5733E3] to-[#6E50E7] hover:opacity-90 rounded-full font-inter"
          >
            Share
          </button>
        )}
      </div>
      <Modal isOpen={inviteModalOpen} closeModal={closeInviteModal}>
        <BottomSheetModalHOC>
          <InviteModal
            channelDetails={channelDetails}
            closeModal={closeInviteModal}
            currentUsername={currentUser.username}
          />
        </BottomSheetModalHOC>
      </Modal>
    </>
  );
};

export default ShareBar;
